import { Props } from "@greeter/matter";
import { classNames } from "@greeter/util";
import css from "./AlertContent.module.scss";

export function AlertContent({ className, ...props}: Props) {
  return <div {...classNames(css.AlertContent)} {...props}></div>
}
